import { useState } from 'react';
import { MemberCompetencyClient, MemberCompetencyDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMemberCompetencyApi = () => {
    const apiClient = new MemberCompetencyClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: MemberCompetencyDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createMemberCompetency(data);
        } catch (err: any) {
            setError(err.message || 'Error creating MemberCompetency');
        } finally {
            setIsLoading(false);
        }
    };

    const createBulk = async (data: MemberCompetencyDTO[]) => {
        setIsLoading(true);
        try {
            await apiClient.createBulkMemberCompetency(data);
        } catch (err: any) {
            setError(err.message || 'Error creating MemberCompetencies');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: MemberCompetencyDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateMemberCompetency(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating MemberCompetency');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getMemberCompetencyById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching MemberCompetency');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchMemberCompetencies(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching MemberCompetencies');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteMemberCompetency(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting MemberCompetency');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, createBulk, edit, getById, search, remove, isLoading, error };
};